import {ModuleWithProviders, NgModule} from '@angular/core';
import {NgxsModule} from '@ngxs/store';
import {defaultRtTitlesConfig, RtTitlesConfig, RtTitlesConfigToken} from './config';
import {RtTitlesService} from './rt-titles.service';
import {RtTitlesState} from './rt-titles.state';

@NgModule({
  imports: [NgxsModule.forFeature([RtTitlesState])],
  providers: [RtTitlesService],
})
export class RtTitlesModule {
  static forRoot(config?: RtTitlesConfig): ModuleWithProviders<RtTitlesModule> {
    return {
      ngModule: RtTitlesModule,
      providers: [
        {
          provide: RtTitlesConfigToken,
          useValue: {...defaultRtTitlesConfig, ...config},
        },
      ],
    };
  }
}
